import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-classes',
  templateUrl: './classes.component.html',
  styleUrls: ['./classes.component.css']
})
export class ClassesComponent {

}
